// One 20 Hz tick in the §2.4 phase order. Phase 0 (commands) already ran at dispatch.
import { releaseVanishedHeld } from './containers.ts';
import type { Ctx } from './ctx.ts';
import { runChutes } from './systems/chuteSystem.ts';
import { runDeposits } from './systems/depositSystem.ts';
import { runEconomy } from './systems/economySystem.ts';
import { runGalleries } from './systems/gallerySystem.ts';
import { runMachines } from './systems/machineSystem.ts';
import { runProgress } from './systems/progressSystem.ts';

export function runTick(c: Ctx): void {
  c.s.tick += 1;
  runDeposits(c); // 1 hold hits + drill counters → deposit damage → spawns (R1, R3)
  runMachines(c); // 2 machines (M3)
  runChutes(c); // 3 chutes, downstream-first (M3)
  runGalleries(c); // 4 galleries (M3)
  // 5 Dock (v0.2)
  runEconomy(c); // 6 income buckets
  runProgress(c); // 7 discoveries / unlocks / goals / tutorial (M4a), stall transitions
  releaseVanishedHeld(c); // a held item a machine consumed / a Gallery fired ends the drag
}
